import { observer } from 'mobx-react'

// import { useMutation, useQuery } from '../../../models/utils/mst-hooks'
// import { Loading } from '../../../components/loading/loading'
import './preferences.scss'

export const Preferences = observer(() => {
  // const { store, isLoading } = useQuery(st => st.data.getProfile())
  // const [logoutResult, logout] = useMutation(mut => mut.data.logout())
  // if (isLoading) return <Loading />

  return (
    <div className="Preferences">
      <h1>Preferences</h1>
    </div>
  )
})
